export default __webpack_public_path__ + "static/media/PM.32c6dabd.svg";